module.exports = __webpack_public_path__ + "static/media/16.08a22524.jpg";